export enum PayinProviderErrorGroup {
  NoResponse = 'no_response',
  AuthError = 'auth_error',
  RateLimited = 'rate_limited',
  ClientError = 'client_error',
  ServerError = 'server_error',
  NoRequisitesReturned = 'no_requisites_returned',
  CascadeLost = 'cascade_lost',
}
